import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var requestProduct = function requestProduct(state, partNumber) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: true,
    inProgress: [].concat(_toConsumableArray(state.inProgress), [partNumber])
  });
};
export var updateProduct = function updateProduct(state, product) {
  var newPartNumber = product.data.id;
  var inProgress = state.inProgress.filter(function (pn) {
    return pn !== newPartNumber;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: inProgress.length > 0,
    inProgress: inProgress,
    completed: [].concat(_toConsumableArray(state.completed), [newPartNumber])
  });
};
export var failedProduct = function failedProduct(state, partNumber) {
  var inProgress = state.inProgress.filter(function (pn) {
    return pn !== partNumber;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: inProgress.length > 0,
    inProgress: inProgress,
    inError: [].concat(_toConsumableArray(state.inError), [partNumber])
  });
};